import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = {
  key: 0,
  class: "summary"
}

import CustomerSelector from "@/components/selectors/customer.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {ref} from "vue"
  import Button from "@/components/button.vue"
  import CustomerSummary from "@/components/summaries/customer.vue"
  import router from "@/router"
  import {Customer} from "@/endpoints/rutsolve/gql/generated/graphql"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'customers',
  setup(__props) {

  const selectedCustomer = ref<Customer>(null)

  function customerRedirect() {
    router.push({
      name: "edit_customer",
      params: {
        customerID: selectedCustomer.value.id
      }
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, { links: [{
        title: 'Create',
        routeName: 'create_customer'
      }] }, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }],
            title: "Customers"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("h1", null, " Customers ", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(CustomerSelector, {
                value: selectedCustomer.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedCustomer).value = $event))
              }, null, 8, ["value"])
            ]),
            (selectedCustomer.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(), _createBlock(CustomerSummary, {
                    key: selectedCustomer.value.id,
                    customerID: selectedCustomer.value.id
                  }, null, 8, ["customerID"])),
                  _createVNode(Button, {
                    title: "Edit",
                    image: require('@/images/edit_icon.png'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (customerRedirect()))
                  }, null, 8, ["image"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})